module.exports = __webpack_public_path__ + "static/colouring_in_present_thumb-24006785967ec94dba90a9a447916fe0.jpg";